import React from "react";
import { Tooltip } from "@mui/material";

/**
 * Wraps a displayed value so hovering shows `title` (typically the same value
 * at higher precision, see utils/hoverPrecision). No title -> renders children
 * untouched, so a missing value doesn't get an empty tooltip.
 */
export default function HoverValue({ title, children }) {
  if (!title) return <>{children}</>;
  return (
    <Tooltip title={title} arrow placement="top">
      <span>{children}</span>
    </Tooltip>
  );
}
